import { getFilters } from './filterData';
import { UserProfileType } from '../../../peekapak-types/DataProtocolTypes';
import styles from './LibraryFilters.module.scss';

interface Props {
  handleChangeFilter: (arg0: string) => void;
  filterArray: string[];
  isBasicUser?: boolean;
  userProfile?: UserProfileType | null;
}

const LibraryFilters = ({ handleChangeFilter, filterArray, isBasicUser, userProfile }: Props): JSX.Element => {
  const handleClick = (e: React.MouseEvent<HTMLButtonElement>, filterValue: string) => {
    handleChangeFilter(filterValue);
    e.currentTarget.blur();
  };

  const filters = getFilters(userProfile);

  return (
    <div className={styles.container}>
      {filters.map((filter) => {
        const value = isBasicUser && filter.valueForFreemium ? filter.valueForFreemium : filter.value;
        const displayName =
          isBasicUser && filter.displayNameForFreemium ? filter.displayNameForFreemium : filter.displayName;
        return (
          <button
            onClick={(e) => handleClick(e, value)}
            key={value}
            className={filterArray.includes(value) ? styles.selected : ''}
          >
            {displayName}
          </button>
        );
      })}
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
      <div className={styles.rowFill} />
    </div>
  );
};

export default LibraryFilters;
